// UTILS
import { defineStore } from "pinia"
import { ref, computed } from "vue"

// API
import { getQuestions, getAudio } from "@/api/s3/index"

// STORES
import { useHelpStore } from "@/components/af/Help/help.store.js"
import { moveActor } from "@/features/move/machines/moveMachine"

// TYPES
import type { Ref } from "vue"
import type { Question } from "@/features/move/store/move.types"

export const useQuestionsStore = defineStore("moveQuestionsStore", () => {
  const helpStore = useHelpStore()

  // Ref
  const items: Ref<Question[]> = ref([])
  const currentIndex: Ref<number> = ref(0)
  const isLastQuestion: Ref<boolean> = ref(false)

  // Computed
  const currentQuestion = computed<Question>(() => {
    return items.value[currentIndex.value]
  })
  const questionsLength = computed(() => items.value.length)

  /**
   * Fetch the questions from the API
   * @returns The questions
   */
  async function fetchQuestions() {
    const data = await getQuestions({ test: "move" })
    items.value = data.questions

    return items.value
  }

  /**
   * Fetch the audios from the API
   */
  function fetchAudios() {
    getAudio({ test: "move" })
  }

  /**
   * If current question is not the last one of the list, increment the index
   */
  async function goNext() {
    if (currentIndex.value === items.value.length - 1) {
      isLastQuestion.value = true
      moveActor.send({ type: "done" })
    } else {
      currentIndex.value++
      if (helpStore.isAudioHelpAccepted) {
        helpStore.startAudioSequence()
      }
    }
  }

  /**
   * Set the current index
   * @param id The index to set
   */
  function setCurrentIndex(id: number) {
    currentIndex.value = id
  }

  return {
    questions: items.value,
    currentIndex,
    currentQuestion,
    questionsLength,
    fetchQuestions,
    fetchAudios,
    goNext,
    isLastQuestion,
    setCurrentIndex,
  }
})
